














import Proxyable from '@/mixins/proxyable';
import { IInventoryAdvancePayment } from '@/models';
import { PropType } from 'vue';
import { mapActions, mapGetters } from 'vuex';

export default Proxyable.extend({
  name: 'InventoryAdvancePaymentAPSpecialistPicker',

  props: {
    inventoryAdvancePayment: {
      type: Object as PropType<IInventoryAdvancePayment>,
      required: true
    },
    externalErrorMessage: {
      type: String,
      default: () => ''
    }
  },

  data() {
    return {
      loading: false,
      errorMessage: ''
    };
  },

  computed: {
    ...mapGetters({
      apSpecialists:
        'inventoryAdvancePayment/getInventoryAdvancePaymentAPSpecialists'
    }),

    errorMessageList(): string[] {
      const errorList = [];
      if (this.externalErrorMessage) {
        errorList.push(this.externalErrorMessage);
      }
      if (this.errorMessage) {
        errorList.push(this.errorMessage);
      }

      return errorList;
    }
  },

  mounted() {
    this.init();
  },

  beforeDestroy() {
    this.errorMessage = '';
  },

  methods: {
    ...mapActions({
      fetchInventoryAdvancePaymentAPSpecialists:
        'inventoryAdvancePayment/fetchInventoryAdvancePaymentAPSpecialists'
    }),

    init() {
      this.loading = true;

      this.fetchInventoryAdvancePaymentAPSpecialists(
        this.inventoryAdvancePayment.id
      )
        .catch(() => {
          this.errorMessage = 'Error getting AP Specialists';
        })
        .finally(() => (this.loading = false));
    }
  }
});
